// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sg-0";
export var checkoutRateBadgeLink = "_sg-1";